import { render, staticRenderFns } from "./dict-type-manage.vue?vue&type=template&id=1e74a110&scoped=true"
import script from "./dict-type-manage.vue?vue&type=script&lang=js"
export * from "./dict-type-manage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e74a110",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\zkdn_workspace\\zhijiao\\bjzyjy-mhwz\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('1e74a110')) {
      api.createRecord('1e74a110', component.options)
    } else {
      api.reload('1e74a110', component.options)
    }
    module.hot.accept("./dict-type-manage.vue?vue&type=template&id=1e74a110&scoped=true", function () {
      api.rerender('1e74a110', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/dict/dict-type-manage.vue"
export default component.exports